import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { AnimateCssDirective } from 'src/app/modules/shared/directives/animatecss.directive';
import { TenantConfigPipe } from 'src/app/modules/shared/pipes/tenantconfig';
import { ScreenWidthDirective } from 'src/app/modules/shared/directives/screen-width.directive';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  imports: [
    ScreenWidthDirective,
    AnimateCssDirective,
    TenantConfigPipe,
    AsyncPipe,
    NgClass,
    NgIf,
  ],
})
export class ErrorPageComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  displayPopupError = null;
  animateContentWrapper = environment.views.loginView.animateContentWrapper;
  animateWrapper = environment.views.loginView.animateWrapper;

  constructor(public store: Store<AppState>) {
    super();
  }

  ngOnInit() {
    this.displayPopupError = localStorage.getItem('login-error-popup-block');
    super.ngOnInitBase();
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }
}
